import QueryString from 'qs';

type Params = {
  [key: string]: string;
};

type Action = {
  type: 'SAVE_PARAMS';
  payload: Params;
};

const currentParams = QueryString.parse(window.location.search, {
  ignoreQueryPrefix: true,
});
const initialState = currentParams as any;

type State = Params;
export const paramsReducer = (
  state: State = initialState,
  action: Action,
): State => {
  switch (action.type) {
    case 'SAVE_PARAMS':
      return {
        ...state,
        ...action.payload,
      };
  }
  return state;
};

export const PARAMS_MODULE_KEY: 'params' = 'params';
export type ParamsGlobalState = { [PARAMS_MODULE_KEY]: State };

export const paramsSelector = (state: ParamsGlobalState) =>
  state[PARAMS_MODULE_KEY];
